module.exports = __webpack_public_path__ + "static/media/clientSatisfaction.7c5cb0f8.png";